import { ROUTE_UI_SECTION_NAME } from '../constants/route'
import { isAdminUserRole } from '../utils/user'

import { useInitData } from './useInitData'
import { useUserData } from './useUserData'

// The external-contact profile endpoints are admin-only on the backend, so
// the NG gate is stricter than useIsUserProfileNGAvailable.
export function useIsExternalContactProfileNGAvailable() {
  const { availableSections } = useInitData()
  const userData = useUserData()

  return (
    !!availableSections?.[ROUTE_UI_SECTION_NAME.userProfileDetail] &&
    isAdminUserRole(userData?.role)
  )
}
